const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
const { getElement } = window.BAO.Utils

class HeaderSearchDropdown extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.eventBus = window.theme.nosto.eventBus
    this.events = window.theme.autocomplete.events
    this.config = window.theme.autocomplete.config

    this.lastResponse = null
  }

  connectedCallback () {
    super.connectedCallback()

    this.initialViewCarousel = this.setInitialViewCarousel()
    this.subscribeToEvents()

    this.handleResize()

    const snapshot = window.theme.autocomplete.stateLayer?.state

    if (snapshot) {
      this.handleResponseUpdated(snapshot)
    }
  }

  setupListeners () {
    super.setupListeners()

    // Resize events
    this.handleResize = this.handleResize.bind(this)

    this.debouncedResize = window.BAO.Utils.debounce((event) => {
      this.handleResize(event)
    }, this.config.debounceMs)

    this.listeners.add(window, 'resize', this.debouncedResize)

    // Input and form events
    this.debouncedHandleInput = window.BAO.Utils.debounce((event) => {
      this.handleInput(event)
    }, this.config.debounceMs)

    this.listeners.add(
      this.els.input.element,
      'input',
      this.debouncedHandleInput,
    )

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.handleSubmit.bind(this),
    )

    this.listeners.add(
      this.externalEls.input.element,
      'input',
      this.debouncedHandleInput,
    )

    this.listeners.add(
      this.externalEls.form.element,
      'submit',
      this.handleSubmit.bind(this),
    )

    // Click events
    this.listeners.add(
      this.els.resultsKeywordsTemplate.element,
      'click',
      this.handleKeywordClick.bind(this),
    )

    this.listeners.add(
      this.els.resultsProducts.element,
      'click',
      this.handleProductCardClick.bind(this),
    )
  }

  subscribeToEvents () {
    this.eventBus.subscribe(
      this.events.STATE.RESPONSE_UPDATED,
      this.handleResponseUpdated.bind(this),
    )

    document.addEventListener(
      'drawer-changed',
      this.handleDrawerChange.bind(this),
    )
  }

  setInitialViewCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.7,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            slides: {
              perView: 2.2,
              spacing: 1,
            },
          },
          [`(min-width: ${breakpoints.lg}px)`]: {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  handleResize () {
    if (window.BAO.MediaBreakpoints.isLg) {
      this.externalEls.dialog.element.setAttribute('popover', 'auto')
      return
    }

    this.externalEls.dialog.element.removeAttribute('popover')
  }

  handleInput (event) {
    this.els.input.element.value = event.target.value
    this.externalEls.input.element.value = event.target.value

    const query = event.target.value.trim()
    if (query === this.lastResponse.activeTerm) return
    this.eventBus.publish(this.events.UI.QUERY_UPDATED, { query })
  }

  handleSubmit (event) {
    if (this.lastResponse?.fetching || !this.lastResponse?.activeTerm) {
      event.preventDefault()
      return
    }

    this.eventBus.publish(this.events.TRACKING.SUBMIT_SEARCH, {
      query: this.els.input.element.value,
    })

    if (!this.lastResponse.redirect) return

    event.preventDefault()
    window.location.href = this.lastResponse.redirect
  }

  handleKeywordClick (event) {
    if (!event.target.closest('.hd-SearchDropdown_Link')) return

    const response = this.lastResponse
    if (!response) return

    this.eventBus.publish(this.events.TRACKING.KEYWORD_CLICKED, {
      request: { query: response.activeTerm },
      results: response.products,
    })
  }

  handleProductCardClick (event) {
    const productCard = event.target.closest('product-card')
    const url = productCard.dataset.productUrl || false
    if (!productCard || !url) return

    this.eventBus.publish(this.events.TRACKING.PRODUCT_CLICKED, {
      productId: productCard.dataset.productId,
      productUrl: productCard.dataset.productUrl,
    })
  }

  handleDrawerChange () {
    if (window.drawers.activeDrawerKey === 'search') {
      setTimeout(() => {
        if (window.BAO.MediaBreakpoints.isLg) {
          this.externalEls.input.element.focus()
        } else {
          this.els.input.element.focus()
        }
      }, 300)

      return
    }

    setTimeout(() => {
      this.els.input.element.value = ''
      this.externalEls.input.element.value = ''
      this.eventBus.publish(this.events.UI.QUERY_UPDATED, { query: '' })
    }, 300)
  }

  handleResponseUpdated (response) {
    this.lastResponse = response
    const view = this.pickView(response)
    this.setView(view)

    if (response.activeTerm && window.drawers?.activeDrawerKey !== 'search') {
      const siteDrawers = getElement('site-drawers')
      siteDrawers.open('search')
    }

    switch (view) {
      case 'results':
        this.renderProducts(response.products, response.activeTerm)
        this.renderKeywords(response.keywords)
        this.renderCategories(response.categories)
        break

      case 'no-results':
        this.renderNoResults(response.activeTerm)
        break

      case 'redirect':
        this.renderRedirect(response.redirect)
        break
    }
  }

  pickView (response) {
    if (response.fetching) return 'initial'

    const hasTerm = response.activeTerm?.length > 1
    const hasHits = response.products?.hits?.length > 0
    const hasRedirect = response.redirect

    if (hasTerm && hasHits) return 'results'
    if (hasTerm && hasRedirect && !hasHits) return 'redirect'
    if (hasTerm && !hasHits) return 'no-results'

    return 'initial'
  }

  setView (view) {
    const views = {
      initial: this.els.initialView.element,
      results: this.els.resultsView.element,
      'no-results': this.els.noResultsView.element,
      redirect: this.els.redirectView.element,
    }

    Object.entries(views).forEach(([name, element]) => {
      if (name === view) {
        element.removeAttribute('hidden')
      } else {
        element.setAttribute('hidden', '')
      }
    })
  }

  renderProducts (products, query) {
    // Update URL
    this.els.resultsProductsLink.element.setAttribute(
      'href',
      `/search?q=${encodeURIComponent(query)}`,
    )

    // Update count
    const titleEl = this.els.resultsProductsTitle.element
    const string = titleEl.dataset.format.replaceAll('[count]', products.total)
    titleEl.textContent = string

    // Update product cards
    const list = this.els.resultsProductsTemplate.element
    list.innerHTML = ''

    products.hits.forEach((product, index) => {
      const productCard = window.templates.ProductCard({
        product,
        index,
        type: 'autocomplete',
      })

      const template = `
        <div class="hd-SearchDropdown_ResultsItem">
          ${productCard}
        </div>
      `
      list.insertAdjacentHTML('beforeend', template)
    })
  }

  renderKeywords (keywords, { skipIfPresent = false } = {}) {
    if (
      skipIfPresent &&
      this.els.resultsKeywords.element.querySelectorAll(
        '.hd-SearchDropdown_ListItem',
      ).length
    ) {
      return
    }

    if (!keywords.hits?.length) {
      this.els.resultsKeywords.element.setAttribute('hidden', '')
      return
    }

    this.els.resultsKeywords.element.removeAttribute('hidden')
    this.els.resultsKeywordsTemplate.element.innerHTML = this.templateKeywords(
      keywords.hits,
    )
  }

  renderCategories (categories) {
    if (!categories.length) {
      this.els.resultsCategories.element.setAttribute('hidden', '')
      return
    }

    this.els.resultsCategories.element.removeAttribute('hidden')
    this.els.resultsCategoriesTemplate.element.innerHTML =
      this.templateCategories(categories)
  }

  renderNoResults (query) {
    const titleEl = this.els.noResultsTitle.element
    const string = titleEl.dataset.format.replaceAll('[query]', query)
    titleEl.innerHTML = string
  }

  renderRedirect (url) {
    this.els.redirectTitle.element.href = url
  }

  escapeHtml (str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  templateKeywords (suggestions) {
    return suggestions
      .map((suggestion) => {
        return `
          <li class="hd-SearchDropdown_ListItem">
            <a
              class="hd-SearchDropdown_Link fz-14_120"
              href="${window.routes.searchUrl}?q=${encodeURIComponent(suggestion.keyword)}"
            >
              ${this.escapeHtml(suggestion.keyword)}
            </a>
          </li>
        `
      })
      .join('')
  }

  templateCategories (categories) {
    return categories
      .map((category) => {
        return `
          <li class="hd-SearchDropdown_ListItem">
            <a
              class="hd-SearchDropdown_Link fz-14_120"
              href="${window.routes.collectionsUrl}/${category.urlPath}"
            >
              ${this.escapeHtml(category.name)}
            </a>
          </li>
        `
      })
      .join('')
  }
}

if (!customElements.get('header-search-dropdown')) {
  customElements.define('header-search-dropdown', HeaderSearchDropdown)
}
